export const defaultMetadata = {
  title: 'Trusted AI Transformation Agency | Yellow',
  description: 'We help businesses turn their AI initiatives into production-grade solutions with measurable results.',
};
